import React from 'react'
import { DataGridPro } from '@mui/x-data-grid-pro';
import CustomLoadingOverlay from '../../common/datagrid/CustomLoadingOverlay'
import CustomToolbar from '../../common/datagrid/CustomToolbar'

const SalesFileList = ({
  apiRef,
  columns,
  files,
  error,
  loading,
}) => {
  return (
    <div style={{ display: 'flex', height: '250px' }}>
    <div style={{ flexGrow: 1 }}>
      <DataGridPro
        apiRef={apiRef}
        rows={files ? files : []}
        columns={columns}
        components={{
          Toolbar: CustomToolbar,
          LoadingOverlay: CustomLoadingOverlay,
        }}
        componentsProps={{
          toolbar: { fileName: '매출발주서_리스트' },
        }}
        loading={loading}
        initialState={{ pinnedColumns: { right: ['actions'] } }}
      />
    </div>
  </div>
  )
}

export default SalesFileList